import { render } from "./AddApprover.vue?vue&type=template&id=0e119490&scoped=true"
import script from "./AddApprover.vue?vue&type=script&lang=js"
export * from "./AddApprover.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e119490"]])

export default __exports__